/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartPieA1Icon16Light } from './DataChartPieA1Icon16Light';
import { DataChartPieA1Icon16Regular } from './DataChartPieA1Icon16Regular';
import { DataChartPieA1Icon16Solid } from './DataChartPieA1Icon16Solid';
import { DataChartPieA1Icon20Light } from './DataChartPieA1Icon20Light';
import { DataChartPieA1Icon20Regular } from './DataChartPieA1Icon20Regular';
import { DataChartPieA1Icon20Solid } from './DataChartPieA1Icon20Solid';
import { DataChartPieA1Icon24Regular } from './DataChartPieA1Icon24Regular';
import { DataChartPieA1Icon24Solid } from './DataChartPieA1Icon24Solid';
import { DataChartPieA1Icon32Regular } from './DataChartPieA1Icon32Regular';
import { DataChartPieA1Icon64Regular } from './DataChartPieA1Icon64Regular';
var sizes = {
    16: {
        light: DataChartPieA1Icon16Light,
        regular: DataChartPieA1Icon16Regular,
        solid: DataChartPieA1Icon16Solid,
    },
    20: {
        light: DataChartPieA1Icon20Light,
        regular: DataChartPieA1Icon20Regular,
        solid: DataChartPieA1Icon20Solid,
    },
    24: {
        regular: DataChartPieA1Icon24Regular,
        solid: DataChartPieA1Icon24Solid,
    },
    32: {
        regular: DataChartPieA1Icon32Regular,
    },
    64: {
        regular: DataChartPieA1Icon64Regular,
    },
};
export var DataChartPieA1Icon = forwardRef('DataChartPieA1Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
